<main-header *ngIf="facade.isLoggedIn$ | async"></main-header>
<div class="not-found-content">
  <error-screen [isShowErrorCode]="showErrorCode"></error-screen>
</div>
